import { z } from "zod"

export const maintenanceTemplateRecordSchema = z.object({
    id: z.uuid(),
    org_id: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    instructions: z.string().nullable(),
    condition_usage_flights: z.coerce.number().int().nullable(),
    condition_duration_hours: z.coerce.number().nullable(),
    condition_interval_value: z.coerce.number().int().nullable(),
    status_on_trigger: z.string(),
    apply_to_all: z.boolean().default(false),
    model_targets: z.array(z.string()).default([]),
})

export const maintenanceTemplateSchema = maintenanceTemplateRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    name: r.name,
    description: r.description,
    instructions: r.instructions,
    conditionUsageFlights: r.condition_usage_flights,
    conditionDurationHours: r.condition_duration_hours,
    conditionIntervalValue: r.condition_interval_value,
    statusOnTrigger: r.status_on_trigger,
    applyToAll: r.apply_to_all,
    modelTargets: r.model_targets,
}))

export const creatableMaintenanceTemplateSchema = maintenanceTemplateRecordSchema
    .omit({ id: true, org_id: true })
    .extend({ aircraft_ids: z.array(z.uuid()).default([]) })

export const updatableMaintenanceTemplateSchema = maintenanceTemplateRecordSchema
    .omit({ id: true, org_id: true })
    .partial()
    .extend({ aircraft_ids: z.array(z.uuid()).optional() })

export type MaintenanceTemplateRecord = z.infer<typeof maintenanceTemplateRecordSchema>
export type MaintenanceTemplate = z.infer<typeof maintenanceTemplateSchema>
export type CreatableMaintenanceTemplate = z.infer<typeof creatableMaintenanceTemplateSchema>
export type UpdatableMaintenanceTemplate = z.infer<typeof updatableMaintenanceTemplateSchema>
